// Inicializa Google Analytics 4 (gtag.js) e Intercom. Port directo
// de keycloakTrackers.js, sólo añadiendo tipos de TS.
//
// `hide_default_launcher: true` oculta la burbuja flotante de Intercom Y
// suprime los pop-ups de mensajes nuevos (badge rojo + card de preview).
// El chat se abre imperativamente desde los enlaces "chatea con
// nosotros" / "contacta con nosotros" llamando a window.Intercom("show").
// Sin esto, en sesiones con mensajes anteriores Intercom muestra un
// preview encima del form de login.

import { getFdPublicConfig } from "./window";

interface IntercomFn {
  (...args: unknown[]): void;
  q?: unknown[][];
  c?: (args: unknown[]) => void;
}

interface TrackerWindow {
  dataLayer?: unknown[];
  Intercom?: IntercomFn;
  intercomSettings?: { app_id: string; hide_default_launcher: boolean };
}

function trackerWindow(): TrackerWindow & Window {
  return window as unknown as TrackerWindow & Window;
}

export function initTrackers() {
  const cfg = getFdPublicConfig();
  const w = trackerWindow();

  // GA4 con el snippet oficial de la etiqueta de Google (gtag.js). Un ID
  // "G-" debe cargarse por /gtag/js, nunca por /gtm.js: gtm.js no procesa
  // los comandos gtag("config") y Google solo los soporta sobre gtag.js.
  if (cfg.GOOGLE_ANALYTICS_MEASUREMENT_ID) {
    const id = cfg.GOOGLE_ANALYTICS_MEASUREMENT_ID;
    w.dataLayer = w.dataLayer ?? [];
    const f = document.getElementsByTagName("script")[0];
    const j = document.createElement("script");
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    f.parentNode?.insertBefore(j, f);

    // Ojo: hay que empujar el objeto `arguments`, no un array. El
    // procesador de dataLayer sólo interpreta como comando gtag lo que
    // llega como [object Arguments]; un Array real —lo que produce un
    // rest param— entra por otra rama y `js`/`config` se ignorarían.
    const gtag: (...args: unknown[]) => void = function () {
      (w.dataLayer as unknown[]).push(arguments);
    };
    gtag("js", new Date());
    gtag("config", id);
  }

  // Intercom
  w.intercomSettings = {
    app_id: cfg.INTERCOM_APP_ID,
    hide_default_launcher: true,
  };

  const ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    const stub: IntercomFn = function (...args: unknown[]) {
      stub.c!(args);
    };
    stub.q = [];
    stub.c = (args) => {
      stub.q!.push(args);
    };
    w.Intercom = stub;
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${cfg.INTERCOM_APP_ID}`;
    const x = document.getElementsByTagName("script")[0];
    x.parentNode?.insertBefore(s, x);
  }
}

export function showIntercom() {
  trackerWindow().Intercom?.("show");
}
